export const API_ROUTES = {
  auth: {
    otpInitiate: "/auth/otp/initiate",
    otpVerify: "/auth/otp/verify",
    login: "/auth/login",
    logout: "/auth/logout",
    requestPasswordReset: "/auth/request-password-reset",
    resetPassword: "/auth/reset-password",
  },
  dashboard: {
    stats: "/dashboard/stats",
  },
  flats: {
    generate: "/flats/generate",
    bySociety: (societyId) => `/flats/society/${societyId}`,
    assigned: "/flats/assigned",
    details: (flatId) => `/flats/${flatId}`,
    unitTypesBulk: "/flats/unit-types/bulk",
    updateStructure: "/flats/update-structure",
    availableStaff: (flatId) => `/flats/${flatId}/available-staff`,
    assignStaff: (flatId) => `/flats/${flatId}/assign-staff`,
    unassignStaff: (flatId) => `/flats/${flatId}/unassign-staff`,
  },
  import: {
    units: "/import-units",
    residents: "/import-residents",
    residentTemplate: "/import-residents/template",
  },
  parking: {
    list: "/parking/slots",
    create: "/parking/slots",
    details: (slotId) => `/parking/slots/${slotId}`,
    update: (slotId) => `/parking/slots/${slotId}`,
    assign: (slotId) => `/parking/slots/${slotId}/assign`,
    unassign: (slotId) => `/parking/slots/${slotId}/unassign`,
    delete: (slotId) => `/parking/slots/${slotId}`,
    generate: "/parking/slots/generate",
  },
  preApprovedInvites: {
    list: "/pre-approved-invites",
    mine: "/pre-approved-invites/my",
    details: (id) => `/pre-approved-invites/${id}`,
    cancel: (id) => `/pre-approved-invites/${id}/cancel`,
  },
  gate: {
    adminEntryLogs: "/admin/gate-entry-logs",
    searchInvite: "/gate/pre-approved-invites/search",
    expectedInvites: "/gate/pre-approved-invites/expected",
    checkInInvite: (id) => `/gate/pre-approved-invites/${id}/check-in`,
    checkOutInvite: (id) => `/gate/pre-approved-invites/${id}/check-out`,
    denyInvite: (id) => `/gate/pre-approved-invites/${id}/deny`,
  },
  societies: {
    list: "/societies",
    create: "/societies",
    details: (id) => `/societies/${id}`,
    icon: (societyId) => `/societies/${societyId}/icon`,
    towers: (societyId) => `/societies/${societyId}/towers`,
    towersBulkCreate: "/societies/towers/bulk",
    configs: (societyId) => `/societies/${societyId}/configs`,
    settings: (societyId) => `/societies/${societyId}/settings`,
    generateUnits: "/societies/units/generate",
    unitTypes: (societyId) => `/societies/${societyId}/unit-types`,
    addUnitType: (societyId) => `/societies/${societyId}/unit-types`,
    deleteUnitType: (societyId, id) => `/societies/${societyId}/unit-types/${id}`,
    unitsByTower: (towerId) => `/societies/towers/${towerId}/units`,
    deleteTower: (towerId) => `/societies/towers/${towerId}`,
    documents: (societyId) => `/societies/${societyId}/documents`,
    deleteDocument: (societyId, docId) => `/societies/${societyId}/documents/${docId}`,
    pendingApprovals: (societyId) => `/societies/${societyId}/approvals`,
    approveRequest: (societyId, requestId) => `/societies/${societyId}/approvals/${requestId}/approve`,
    rejectRequest: (societyId, requestId) => `/societies/${societyId}/approvals/${requestId}/reject`,
    directoriesEmployeeFormData: (societyId) => `/societies/${societyId}/directories/employee-form-data`,
    directoriesResidents: (societyId) => `/societies/${societyId}/directories/residents`,
    directoriesResidentsExport: (societyId) => `/societies/${societyId}/directories/residents/export`,
    directoriesResidentsTemplate: (societyId) => `/societies/${societyId}/directories/residents/template`,
    directoriesResidentsImport: (societyId) => `/societies/${societyId}/directories/residents/import`,
    updateResident: (societyId, userId) => `/societies/${societyId}/directories/residents/${userId}`,
    revokeResident: (societyId, userId) => `/societies/${societyId}/directories/residents/${userId}/revoke`,
    directoriesTenants: (societyId) => `/societies/${societyId}/directories/tenants`,
    directoriesVehicles: (societyId) => `/societies/${societyId}/directories/vehicles`,
    directoriesPets: (societyId) => `/societies/${societyId}/directories/pets`,
    directoriesHotlines: (societyId) => `/societies/${societyId}/directories/hotlines`,
    saveHotline: (societyId) => `/societies/${societyId}/directories/hotlines`,
    deleteHotline: (societyId, hotlineId) => `/societies/${societyId}/directories/hotlines/${hotlineId}`,
    directoriesStaff: (societyId) => `/societies/${societyId}/directories/staff`,
    inviteStaff: (societyId) => `/societies/${societyId}/staff/invite`,
    gates: (societyId) => `/societies/${societyId}/gates`,
    updateGate: (societyId, gateId) => `/societies/${societyId}/gates/${gateId}`,
    deleteGate: (societyId, gateId) => `/societies/${societyId}/gates/${gateId}`,
    assignGateStaff: (societyId, gateId) => `/societies/${societyId}/gates/${gateId}/assign`,
    unassignGateStaff: (societyId, gateId) => `/societies/${societyId}/gates/${gateId}/unassign`,
    updateStaff: (societyId, staffId) => `/societies/${societyId}/directories/staff/${staffId}`,
    deleteStaff: (societyId, staffId) => `/societies/${societyId}/directories/staff/${staffId}`,
    committee: (societyId) => `/societies/${societyId}/committee`,
    assignCommitteeRole: (societyId) => `/societies/${societyId}/committee/assign`,
    revokeCommitteeRole: (societyId, memberId) => `/societies/${societyId}/committee/${memberId}/revoke`,
    testers: (propertyId) => `/societies/${propertyId}/testers`,
    createTester: (propertyId) => `/societies/${propertyId}/testers`,
    updateTester: (propertyId, userId) => `/societies/${propertyId}/testers/${userId}`,
    deleteTester: (propertyId, userId) => `/societies/${propertyId}/testers/${userId}`,
  },
  societyAdmins: {
    list: "/society-admins",
    details: (id) => `/society-admins/${id}`,
  },
  supportTickets: {
    create: "/support-tickets",
    mine: "/support-tickets/my",
    admin: "/support-tickets/admin",
    status: (ticketId) => `/support-tickets/${ticketId}/status`,
  },
  systemLogs: {
    system: "/system-logs",
    audit: "/audit-logs",
    myAudit: "/audit-logs/me",
  },
  users: {
    list: "/users",
    me: "/users/me",
    details: (id) => `/users/${id}`,
    flats: (userId) => `/users/${userId}/flats`,
    stats: "/users/stats",
    activate: (id) => `/users/${id}/activate`,
  },
  visitors: {
    types: "/visitor-types",
    resolveResident: "/visitor-entries/resolve-resident",
    entries: "/visitor-entries",
    guardEntries: "/guard/visitor-entries",
    checkIn: (id) => `/visitor-entries/${id}/check-in`,
    checkOut: (id) => `/visitor-entries/${id}/check-out`,
    residentRequests: "/resident/visitor-requests",
    approve: (id) => `/visitor-entries/${id}/approve`,
    reject: (id) => `/visitor-entries/${id}/reject`,
  },
  settings: {
    base: "/settings",
    roles: "/settings/roles",
  },
  amenities: {
    base: "/amenities",
  },
  admin: {
    preApprovedInvites: "/admin/pre-approved-invites",
    gateEntryLogs: "/admin/gate-entry-logs",
    inviteStats: "/admin/stats",
    blockInvite: (id) => `/admin/${id}/block`,
  },
  deletionRequests: "/deletion-requests",
  masters: {
    roles: "/masters/roles",
    propertyTypes: "/masters/property-types",
    createPropertyType: "/masters/property-types",
    updatePropertyType: (id) => `/masters/property-types/${id}`,
    deletePropertyType: (id) => `/masters/property-types/${id}`,
    deliveryCompanies: "/masters/delivery-companies",
    updateDeliveryCompany: (id) => `/masters/delivery-companies/${id}`,
    deleteDeliveryCompany: (id) => `/masters/delivery-companies/${id}`,
    cabProviders: "/masters/cab-providers",
    updateCabProvider: (id) => `/masters/cab-providers/${id}`,
    deleteCabProvider: (id) => `/masters/cab-providers/${id}`,
    propertyDeliveryNetwork: (propertyId) => `/masters/properties/${propertyId}/delivery-network`,
    togglePropertyDelivery: (propertyId) => `/masters/properties/${propertyId}/delivery-network`,
    propertyCabNetwork: (propertyId) => `/masters/properties/${propertyId}/cab-network`,
    togglePropertyCab: (propertyId) => `/masters/properties/${propertyId}/cab-network`,
    industrialSettings: (propertyId) => `/masters/properties/${propertyId}/industrial-settings`,
    updateIndustrialSettings: (propertyId) => `/masters/properties/${propertyId}/industrial-settings`,
    locations: (propertyId) => `/masters/properties/${propertyId}/locations`,
    departments: (propertyId) => `/masters/properties/${propertyId}/departments`,
    departmentTypes: "/masters/department-types",
    updateDepartmentType: (id) => `/masters/department-types/${id}`,
    deleteDepartmentType: (id) => `/masters/department-types/${id}`,
  },
  industrial: {
    visits: "/industrial/visits",
    action: (id) => `/industrial/visits/${id}/action`,
    override: (id) => `/industrial/visits/${id}/override`,
    checkIn: (id) => `/industrial/visits/${id}/check-in`,
    checkOut: (id) => `/industrial/visits/${id}/check-out`,
    drafts: "/industrial/guard/drafts",
    createDraft: "/industrial/guard/draft",
    clockIn: "/industrial/guard/duty/clock-in",
    clockOut: "/industrial/guard/duty/clock-out",
  },
};

export default API_ROUTES;
